import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Encounter } from '../data/student-report';
import { GeneratedArtifact } from '../data/artifact';

@Component({
  selector: 'app-encounter-display-vocab-say',
  templateUrl: './encounter-display-vocab-say.component.html',
  styleUrls: ['./encounter-display-vocab-say.component.css']
})
export class EncounterDisplayVocabSayComponent extends BaseComponent implements OnChanges {

  @Input() encounters: Encounter[];
  @Input() artifacts: GeneratedArtifact[];
  @Input() studentId: number;
  getDescription = Encounter.getDescription;

  ngOnChanges() {
  }

}
